import React, { useMemo } from 'react';
import { Tabs } from '@shared/components/Tabs';
import type { TabItemProps } from '@shared/components/Tabs/Tabs';
import { useTranslation } from '@shared/core';

export enum VisualType {
  ANIMATION = 'animation',
  IMAGE = 'image',
}

type SwitchProps = Readonly<{
  selectedVisualType: VisualType;
  setSelectedVisualType: (type: VisualType) => void;
}>;

export const Switch: React.FC<SwitchProps> = ({ selectedVisualType, setSelectedVisualType }) => {
  const { tq } = useTranslation('contactCollector');

  const items: TabItemProps[] = useMemo(
    () => [
      {
        label: 'animation',
        value: tq`Animation`,
        isActive: selectedVisualType === VisualType.ANIMATION,
        onClick: () => setSelectedVisualType(VisualType.ANIMATION),
      },
      {
        label: 'image',
        value: tq`Image`,
        isActive: selectedVisualType === VisualType.IMAGE,
        onClick: () => setSelectedVisualType(VisualType.IMAGE),
      },
    ],
    [tq, selectedVisualType, setSelectedVisualType],
  );

  return (
    <Tabs
      items={items}
      width="100%"
      tabTextProps={{ typographyVariant: 'body3' }}
    />
  );
};
